// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/*this is to prevent scrolling to top when modal opens*/\nbody.modal-open {\n    overflow: visible;\n}\n", ""]);
// Exports
module.exports = exports;
